import { PurpleSide } from 'components/Header/styled'
import Container from 'elements/Container'
import React from 'react'
import { Sales } from './Sales'
import {
  Achievement,
  FooterContent,
  PurpleFootContent,
  CardTitle,
  Card,
  ResponsiveButtonPink,
  ButtonOutlined,
  CardList,
  Footer,
  Wrapper,
  PlaceholderWrapper
} from './styled'
import ComingSoon from 'components/ComingSoon'

const HeaderPlaceholder = (
  <div
    style={{
      width: '100%',
      height: '200px',
      background: 'linear-gradient(91.93deg, #522ba4 2.6%, #d06cff 100%)',
      borderRadius: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 'auto'
    }}
  >
    <PlaceholderWrapper>
      <PurpleSide>BOXY</PurpleSide>GUILD.
    </PlaceholderWrapper>
  </div>
)

const SmallPlaceholder = (
  <div
    style={{
      width: '80px',
      height: '80px',
      background: 'linear-gradient(123.67deg, #522BA4 -7.35%, #D06CFF 88.87%)',
      borderRadius: '24px'
    }}
  ></div>
)

const Farms: React.FC = () => {
  // return (
  //   <Container>
  //     <ComingSoon />
  //   </Container>
  // )

  return (
    <Container>
      <div style={{ padding: '0' }}>{HeaderPlaceholder}</div>
      <Wrapper>
        <Card>
          <CardTitle>Basic Sale</CardTitle>
          <div style={{ paddingTop: '25px' }}>
            {Sales.map(sale => (
              <CardList key={sale.title}>
                <div>{sale.title}</div>
                <div style={{ fontWeight: 700 }}>{sale.number}</div>
              </CardList>
            ))}
          </div>
          <ResponsiveButtonPink>Connect Wallet</ResponsiveButtonPink>
        </Card>
        <Card>
          <CardTitle>Unimited Sale</CardTitle>
          <div style={{ paddingTop: '25px' }}>
            {Sales.map(sale => (
              <CardList key={sale.title}>
                <div>{sale.title}</div>
                <div style={{ fontWeight: 700 }}>{sale.number}</div>
              </CardList>
            ))}
          </div>
          <ResponsiveButtonPink>Connect Wallet</ResponsiveButtonPink>
        </Card>
      </Wrapper>
      <Footer>
        <FooterContent>
          <div>{SmallPlaceholder}</div>
          <Achievement>
            <div style={{ fontSize: '14px' }}>Achievement</div>
            <div style={{ fontSize: '20px', fontWeight: 500 }}>IGO Shopper: BOXYGUILD (BXYG)</div>
            <div style={{ fontSize: '16px' }}>Commit -0.054 LP in total to earn!</div>
          </Achievement>
        </FooterContent>
        <PurpleFootContent>
          <div>Learn more about BOXYGUILD (BXYG)</div>
          <div style={{ paddingTop: '10px' }}>View Contract</div>
        </PurpleFootContent>
      </Footer>
      {/* <ButtonOutlined>Close</ButtonOutlined> */}
    </Container>
  )
}

export default Farms
